module.exports = __webpack_public_path__ + "img/curtain_up_100.465feae1.svg";